import { useTranslation } from "react-i18next"
import { ProductCategories } from "components/Navbar/types"
import { Preview } from "components/Preview"
import { Card, CardContent } from "@/components/ui/card"
import { type ProductV2 } from "types"

interface MakeupPreviewPanelProps {
  productItem: ProductV2
  disabled: boolean
  activeColorIndex: number
  onActiveColorIndexChange: (index: number) => void
}

export const MakeupPreviewPanel = ({
  productItem,
  disabled,
  activeColorIndex,
  onActiveColorIndexChange,
}: MakeupPreviewPanelProps) => {
  const { t } = useTranslation()

  if (disabled)
    return (
      <Card
        className="w-full max-w-[640px] self-start overflow-hidden"
        data-testid="makeup-preview-disabled"
      >
        <CardContent className="p-4">
          <div className="flex aspect-square w-full items-center justify-center rounded-xl border border-dashed bg-muted/20 px-6 text-center">
            <p className="text-sm text-muted-foreground">{t("productPage.previewPlaceholder")}</p>
          </div>
        </CardContent>
      </Card>
    )

  return (
    <Card className="w-full max-w-[640px] self-start overflow-hidden" data-testid="makeup-preview">
      <CardContent className="flex flex-col gap-5 p-4">
        <Preview
          type={ProductCategories.MAKEUP}
          productItem={productItem}
          activeColorIndex={activeColorIndex}
          setActiveColorIndex={onActiveColorIndexChange}
        />
      </CardContent>
    </Card>
  )
}
